import { TableCell } from "@/components/ui";
import { DataTableCellText } from "@/components/ui/shadcn/DataTable/DataTableCellText";
import { cn } from "@/lib/utils/cn";
import { type Cell, flexRender } from "@tanstack/react-table";

import { type CSSProperties } from "react";

// needed for row & cell level scope DnD setup
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import type { DataTableColumnMeta } from "./DataTable";

export function DragAlongCell<T>({
  cell,
  className,
}: {
  cell: Cell<T, unknown>;
  className?: string;
}) {
  const { isDragging, setNodeRef, transform } = useSortable({
    id: cell.column.id,
  });

  const style: CSSProperties = {
    opacity: isDragging ? 0.6 : 1,
    position: "relative",
    transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
    transition: isDragging ? "none" : "transform 200ms ease-in-out",
    minWidth: cell.column.getSize(),
    zIndex: isDragging ? 1 : 0,
  };
  const meta = cell.column.columnDef.meta as DataTableColumnMeta | undefined;

  return (
    <TableCell
      style={style}
      ref={setNodeRef}
      className={cn("h-10 px-4", className, meta?.cellClassName)}
    >
      <DataTableCellText canHide={cell.column.getCanHide()}>
        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </DataTableCellText>
    </TableCell>
  );
}
